<template>
  <div class="content animate-panel">
    <div v-if="dashboardIframeUrl" class="box-dashboard-iframe">
      <iframe id="dashboard-iframe" :src="dashboardIframeUrl" width="100%" height="" frameborder="0"
        allowTransparency="true" />
    </div>
  </div>
</template>

<script>
import AnalysisService from '@/services/analysisservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      loader: null,
      analysisId: null,
      dashboardIframeUrl: null
    }
  },
  computed: {
    analysisMenu () {
      return this.$store.getters.getAnalysisMenu
    }
  },
  created () {
    this.analysisId = this.$route.params.id
    this.getDashboard()
  },
  methods: {
    getDashboard () {
      this.loader = this.$loading.show()
      this.dashboardIframeUrl = null
      const params = {
        dispOrder: this.analysisId
      }
      AnalysisService.getDashboard(params)
        .then(response => {
          this.dashboardIframeUrl = response.data.url
          setTimeout(() => {
            this.loader && this.loader.hide()
            this.handleSetIframe()
          }, 2500)
        })
        .catch(error => {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    handleSetIframe () {
      $('#dashboard-iframe', window.parent.document).height($('body').height() - 150)
      $('#dashboard-iframe', window.parent.document).addClass('bg-white')
    }
  },
  mounted () {
    const menu = this.analysisMenu.find((item) => { return item.dispOrder === this.analysisId })
    let logParams = {
      name: eventCode.analysis.show,
      properties: {
        menuName: menu.menuName
      }
    }
    EventService.postTrackLog(logParams)
  },
  watch: {
    $route (to, from) {
      if (to.name === 'Analysis' && this.analysisId !== to.params.id) {
        this.analysisId = to.params.id
        this.getDashboard()
      }
    }
  }
}
</script>

<style scoped>
  .animate-panel {
    padding-right: 5px !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/Analysis.vue